// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecordsDetailsDto
 */
export interface IRecordsDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    record_counts?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    successful_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    processing_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    created_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    updated_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    no_change_records_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordsDetailsDto
     */
    error_records_count?: number;
}

/**
 * Check if a given object implements the IRecordsDetailsDto interface.
 */
export function instanceOfIRecordsDetailsDto(value: object): value is IRecordsDetailsDto {
    return true;
}

export function IRecordsDetailsDtoFromJSON(json: any): IRecordsDetailsDto {
    return IRecordsDetailsDtoFromJSONTyped(json, false);
}

export function IRecordsDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordsDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_counts': json['record_counts'] == null ? undefined : json['record_counts'],
        'successful_records_count': json['successful_records_count'] == null ? undefined : json['successful_records_count'],
        'processing_records_count': json['processing_records_count'] == null ? undefined : json['processing_records_count'],
        'created_records_count': json['created_records_count'] == null ? undefined : json['created_records_count'],
        'updated_records_count': json['updated_records_count'] == null ? undefined : json['updated_records_count'],
        'no_change_records_count': json['no_change_records_count'] == null ? undefined : json['no_change_records_count'],
        'error_records_count': json['error_records_count'] == null ? undefined : json['error_records_count'],
    };
}

export function IRecordsDetailsDtoToJSON(json: any): IRecordsDetailsDto {
    return IRecordsDetailsDtoToJSONTyped(json, false);
}

export function IRecordsDetailsDtoToJSONTyped(value?: IRecordsDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_counts': value['record_counts'],
        'successful_records_count': value['successful_records_count'],
        'processing_records_count': value['processing_records_count'],
        'created_records_count': value['created_records_count'],
        'updated_records_count': value['updated_records_count'],
        'no_change_records_count': value['no_change_records_count'],
        'error_records_count': value['error_records_count'],
    };
}

